<div class="transition-all duration-300 relative z-0"
  [ngClass]="tableWrapperClass || ('h-full overflow-hidden rounded-2xl dark:bg-surface-1 bg-white ' + backdropBlurClass)">
  @if(tableData?.length){

  <!-- <div class="dark:text-purple-300 text-purple-700 py-3">
        Paginated Table
        <p class="dark:text-slate-400 text-slate-700 text-sm">
            Table with pagination controls
        </p>
    </div> -->
  <div class="rounded-2xl w-full"
    [ngClass]="[containerClass, hideOuterBorder ? '' : 'border border-[#EAEAEA] dark:border-line']">
    <table class="w-full" [ngClass]="tableClass">
      <thead class="sticky top-0 z-10">
        @if(headers){
        <tr [ngStyle]="{
            'background-color': headerBgColor
              ? isDarkTheme()
                ? headerBgColor.dark || '#232327'
                : headerBgColor.light || '#F5F5F5'
              : null
          }" [ngClass]="[headerClass, headerBorderClass, headerDefaultBgClass]" class="overflow-hidden">
          <!-- Checkbox Column Header -->
          @if(isCheckboxShow){
          <th class="text-left w-12" [ngClass]="[headerRoundedClass, cellPaddingClass]">
            <div class="flex items-center justify-center">
              <input type="checkbox" [checked]="isAllSelected()" [indeterminate]="isSomeSelected()"
                (change)="toggleAllRows($event)" [disabled]="!hasSelectableRows()"
                class="w-4 h-4 rounded cursor-pointer transition-all duration-150 hover:scale-110 disabled:cursor-not-allowed disabled:opacity-40"
                aria-label="Select all rows" />
            </div>
          </th>
          } @if(showSeriesNo){
          <th class="w-12" [ngClass]="cellPaddingClass">
            <div class="flex items-center justify-center"></div>
          </th>
          } @for(h of headers; track $index){
          <ng-container>
            @if(!h.isPrevious || previousData?.length){
            <th [ngStyle]="{
                color: headerTextColor
                  ? isDarkTheme()
                    ? headerTextColor.dark || '#D4D4D8'
                    : headerTextColor.light || '#7D7D93'
                  : null
              }" [ngClass]="[getHeaderAlignClass(h), h.colClass || '', headerRoundedClass, cellPaddingClass]"
              class="font-normal dark:text-ink-soft text-[#7D7D93] text-sm tracking-wide transition-colors duration-200 whitespace-normal 2xl:whitespace-nowrap"
              [class.cursor-pointer]="h.sortable !== false" (click)="sortData(tableData || [], h.label, tableKey)">
              <div class="flex items-center gap-2" [ngClass]="getHeaderJustifyClass(h)">
                <span>{{ h.label }}</span>
                <span *ngIf="h.sortable !== false && sortState[tableKey]?.key?.toLowerCase() ===
                        h.label.toLowerCase() &&
                      sortState[tableKey]?.order === 'asc'" class="ml-1 flex items-center">
                  <app-icon-v2 size="20" name="ArrowUp" [style.color]="
                      (sortIconColor &&
                        (isDarkTheme()
                          ? sortIconColor.dark
                          : sortIconColor.light)) ||
                      '#7C3AED'
                    " class="w-4 h-4"></app-icon-v2>

                  <app-icon-v2 *ngIf="
                      sortState[tableKey]?.key?.toLowerCase() ===
                        h.label.toLowerCase() &&
                      sortState[tableKey]?.order === 'desc'
                    " size="20" name="ArrowDown" [style.color]="
                      (sortIconColor &&
                        (isDarkTheme()
                          ? sortIconColor.dark
                          : sortIconColor.light)) ||
                      '#7C3AED'
                    " class="w-4 h-4"></app-icon-v2>

                  <app-icon-v2 *ngIf="
                      sortState[tableKey]?.key?.toLowerCase() !==
                        h.label.toLowerCase() && h.isSortIconShow
                    " size="20" name="ArrowDown" [style.color]="
                      (sortIconColor &&
                        (isDarkTheme()
                          ? sortIconColor.dark
                          : sortIconColor.light)) ||
                      '#7C3AED'
                    " class="w-4 h-4"></app-icon-v2>
                </span>
                @if(!h.isPrevious && h.showProgress && previousData?.length){
                <span
                  class="inline-flex items-center rounded-full border text-[10px] px-2 py-0.5 font-semibold shadow-sm transition-all duration-200 hover:scale-105 leading-none whitespace-nowrap flex-shrink-0"
                  [ngClass]="{
                    'bg-gradient-to-r from-emerald-50 to-emerald-100 text-emerald-700 border-emerald-200 dark:from-emerald-900/30 dark:to-emerald-800/30 dark:text-emerald-400 dark:border-emerald-700':
                      finalValue.type === 'Profit',
                    'bg-gradient-to-r from-red-50 to-red-100 text-red-700 border-red-200 dark:from-red-900/30 dark:to-red-800/30 dark:text-red-400 dark:border-red-700':
                      finalValue.type === 'Loss',
                    'bg-gradient-to-r from-gray-50 to-gray-100 text-gray-600 border-gray-200 dark:from-gray-800/30 dark:to-gray-700/30 dark:text-gray-400 dark:border-gray-600':
                      finalValue.type === 'No Profit No Loss'
                  }">
                  <!-- <span class="mr-0.5 text-[11px] font-bold">{{ finalValue.type === 'Profit' ? '↑' : finalValue.type === 'Loss' ? '↓' : '=' }}</span> -->
                  <span class="font-medium">{{ finalValue.percent }}%</span>
                </span>

                }
              </div>
            </th>
            }
          </ng-container>
          }
          @if(tableActionOptions.showToggleButton){
          <th [ngClass]="[headerRoundedClass, cellPaddingClass]"
            class="font-normal dark:text-ink-soft text-[#7D7D93] text-sm tracking-wide text-center w-28">
            <div class="flex items-center justify-center">
              <span>{{ tableActionOptions.columnLabel || 'Actions' }}</span>
            </div>
          </th>
          }
        </tr>
        }
      </thead>

      <tbody class="">
        @for(row of paginatedData; track $index; let i = $index){
        <!-- transition-all duration-150 hover:bg-linear-to-r hover:from-[#F2F7FF] hover:to-[#FAFCFF] hover:shadow-sm cursor-pointer group -->
        <tr
          [ngClass]="['transition-colors duration-200 hover:bg-[#f5f5f5] dark:hover:bg-slate-800/30', rowBorderClass, i !== paginatedData?.length! - 1 ? 'border-b' : '']"
          [class.animate-fadeIn]="true" [style.animation-delay]="i * 50 + 'ms'">
          <!-- Checkbox Column Cell -->
          @if(isCheckboxShow){
          <td class="w-12" [ngClass]="cellPaddingClass">
            <div class="flex items-center justify-center">
              <input type="checkbox" [checked]="isRowSelected(row, i)" (change)="toggleRowSelection(row, i, $event)"
                (click)="$event.stopPropagation()" [disabled]="!isRowSelectable(row)"
                class="w-4 h-4 rounded transition-all duration-150 disabled:cursor-not-allowed"
                [class.cursor-pointer]="isRowSelectable(row)" [class.hover:scale-110]="isRowSelectable(row)"
                [attr.aria-label]="'Select row ' + (i + 1)" />
            </div>
          </td>
          } @if(showSeriesNo){
          <td class="w-12" [ngClass]="cellPaddingClass">
            <div class="flex items-center justify-center">
              {{ i + 1 }}
            </div>
          </td>
          } @for(h of headers; track $index){
          <ng-container>
            @if(!h.isPrevious || previousData?.length){
            <td [ngClass]="[h.align || 'text-left', h.colClass || '', cellPaddingClass]"
              class="break-words dark:text-white text-[#141437] font-normal transition-colors duration-150"
              (mouseover)="triggerTooltip($event, h, resolveRow(h, row, i))" (mouseleave)="hideTooltip()"
              (mousemove)="showTooltip($event)">
              @if (cellTemplates[h.key]) {
              <ng-container [ngTemplateOutlet]="cellTemplates[h.key]"
                [ngTemplateOutletContext]="{ $implicit: row, index: i, header: h }"></ng-container>
              } @else {
              @switch (h.key) {
              @case ('action') {
              <div [innerHTML]="row[h.key]" (click)="toggleView(row)"
                class="inline-flex items-center gap-1 text-[#0066CC] hover:text-[#0052A3] font-semibold transition-colors duration-150 cursor-pointer">
              </div>
              }
              @default {
              <div [ngClass]="{ 'flex gap-2 items-center justify-start': row.icon && h.showIcon }">
                <p [ngClass]="{
                          'justify-start': h.align === 'text-left',
                          'justify-center': h.align === 'text-center',
                          'justify-end': h.align === 'text-right'
                        }" class="mb-0 flex items-center gap-1 text-sm">
                  @if (h.cellType === 'badge' || h.cellType === 'pill') {
                  <span class="inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-medium"
                    [ngClass]="resolveRow(h, row, i)[h.key + '_class'] || h.cellClass">
                    {{ getValue(h.key, resolveRow(h, row, i), i, h.transform, h) }}
                    @if (h.cellType === 'pill') { % }
                  </span>
                  } @else if (h.isHtml) {
                  <span [innerHTML]="getValue(h.key, resolveRow(h, row, i), i, h.transform, h)"></span>
                  } @else {
                  <!-- DEFAULT (UNCHANGED) -->
                <div class="flex flex-col">
                  <span class="font-medium">
                    {{ h.key === 'index'
                    ? (i + 1 + (currentPage - 1) * pageSize) + '.'
                    : getValue(h.key, resolveRow(h, row, i), i, h.transform, h)
                    }}
                  </span>
                  @if (h.subKey) {
                  <span class="text-[12px] leading-tight text-slate-500 dark:text-slate-400 mt-0.5 font-normal">
                    {{ getSubValue(h, row, i) }}
                  </span>
                  }
                </div>
                <!-- Inline Growth Indicator -->
                @if(h.growthKey && row[h.growthKey] !== undefined) {
                <span
                  class="inline-flex items-center gap-0.5 ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-medium transition-all duration-200"
                  [ngClass]="{
                                             'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400': row[h.growthKey] >= 0,
                                             'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400': row[h.growthKey] < 0
                                         }">
                  <app-icon-v2 [name]="row[h.growthKey] >= 0 ? 'trendingUp' : 'trendingDown'" size="12" />
                  {{ Math.abs(row[h.growthKey]) }}%
                </span>
                }
                }
                @if (row?.showInlineProgress && (row[h?.key ?? ''] >= 0 || (previousData?.length &&
                previousData?.[i][h?.key ?? ''] >= 0)) && !h?.isPrevious) {
                <ng-container>
                  @for (progress of getProgressForRow(row, $safeNavigationMigration(previousData?.[i]), h.key); track $index) {
                  @if (progress.amount != 0) {
                  <span
                    class="inline-flex items-center text-xs font-bold px-1.5 py-0.5 rounded transition-all duration-150 hover:scale-105"
                    [style.color]="progress.type == 'Loss' ? 'rgba(205, 65, 12, 1)' : 'rgba(17, 207, 118, 1)'"
                    [style.background]="progress.type == 'Loss' ? 'rgba(255, 237, 213, 0.5)' : 'rgba(223, 255, 240, 0.5)'">
                    <span class="mr-0.5">{{ progress.type == "Loss" ? "↓" : "↑" }}</span>
                    {{ progress?.percent }}%
                  </span>
                  }
                  }
                </ng-container>
                }
                </p>
              </div>
              }
              }
              }
            </td>
            }
          </ng-container>
          } @if(tableActionOptions.showToggleButton){
          <td class="w-28" [ngClass]="cellPaddingClass">
            <div class="flex items-center gap-3 justify-center">
              <!-- Loop through action icons -->
              <ng-container *ngFor="let opt of tableActionOptions.toggleOptions">
                @if(opt?.isShow && (!opt.visibilityKey || row[opt.visibilityKey])){
                @if (opt.isButton) {
                <button
                  class="px-3 py-1.5 rounded-md text-white text-sm font-medium transition flex items-center justify-center hover:opacity-90 min-w-max cursor-pointer"
                  [style.backgroundColor]="opt.color || '#A446FF'" [title]="opt.tooltip || ''"
                  (click)="selectAction(opt, row, $event)">
                  {{ opt.label }}
                </button>
                } @else {
                <button
                  class="p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition flex items-center justify-center cursor-pointer"
                  [title]="opt.tooltip || ''" (click)="selectAction(opt, row, $event)">
                  @if (tableActionOptions.useIconV2) {
                  <app-icon-v2
                    [customClass]="opt.color ? 'flex cursor-pointer' : 'flex text-slate-700 dark:text-slate-300 cursor-pointer'"
                    [style.color]="opt.color" size="18" [name]="opt.iconName"></app-icon-v2>
                  } @else {
                  <app-icon-v2 [style.color]="opt.color" size="18" [name]="opt.iconName"
                    [customClass]="opt.color ? 'cursor-pointer' : 'text-slate-700 dark:text-slate-300 cursor-pointer'"></app-icon-v2>
                  }
                </button>
                }
                }
              </ng-container>
            </div>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- <div class="bottom-[22px] left-0 right-0 px-12">

    <app-pagination [currentPage]="currentPage" [pageSize]="pageSize" [totalItems]="totalItems || tableData?.length || 0"
        (pageChange)="changePage($event)"></app-pagination>
</div> -->

  } @else {
  <!-- Empty State -->
  <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500" [ngClass]="className">
    <app-icon-v2 name="Inbox" size="64" customClass="text-gray-300 mb-4"></app-icon-v2>
    <p class="text-lg font-medium">No data available</p>
    <p class="text-sm mt-1">Data will appear here when available</p>
  </div>
  }

  <!-- Enhanced Tooltip -->
  <div #tableTooltip
    class="table-tooltip absolute hidden bg-[#272D35] text-white rounded-lg p-3 shadow-xl z-50 max-w-xs transition-opacity duration-200 border border-gray-600"
    [innerHTML]="tooltipHTML" style="pointer-events: none"></div>
</div>

@if(tableData?.length && !hidePagination){
<div [ngClass]="{ 'border-t': !hidePaginationTopBorder }"
  class="bottom-[22px] left-0 right-0 mt-0 dark:border-line border-[#EAEAEA]">
  <app-pagination [currentPage]="currentPage" [pageSize]="pageSize"
    [totalItems]="serverSide ? totalItems : (totalItems || tableData?.length || 0)"
    [pageCount]="serverSide ? pageCount : null" [currentPageItemCount]="serverSide ? (tableData?.length ?? 0) : null"
    (pageChange)="changePage($event)" [paddingXAxis]="paddingXAxis" [paddingYAxis]="paddingYAxis"></app-pagination>
</div>
}